import React from "react";
import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import DateTimeUtil from "../../../utils/DateTimeUtil";
import InjectedSelect from "../injected-select.jsx";

import {
  RaisedButton,
  TextField,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
  Toggle
} from "material-ui";

const transactionLogGroups = [
  { value: "WEEKLY", label: "Weekly > Category" },
  { value: "MONTHLY", label: "Monthly > Category" },
  { value: "STANDARD WEEKLY", label: "Category > Weekly" },
  { value: "STANDARD MONTHLY", label: "Category > Monthly" },
  { value: "NO GROUPING", label: "No Grouping" }
];

class CustomLedgerScheduleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBuckets: null,
      nickname: "",
      grouping: "NO GROUPING",
      tClass: null,
      tType: null,
      includeNameAndEmail: false,
      showEventFilter: false
    };

    this.handleParentStateUpdate = this.handleParentStateUpdate.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    const item = this.props.item;
    let eventBuckets = [];
    if (item.event_bucket && item.event_bucket.length > 0) {
      eventBuckets = item.event_bucket.map(e => {
        if (e._id) {
          return e._id;
        } else {
          return e;
        }
      });
    }
    this.setState({
      selectedBuckets:
        item.conditions && item.conditions.selectedEvent
          ? eventBuckets[0]
          : eventBuckets,
      nickname: item.nickname,
      grouping: item.conditions ? item.conditions.timePeriod : null,
      tClass: item.conditions ? item.conditions.tClass : null,
      tType: item.conditions ? item.conditions.tType : null,
      includeNameAndEmail: item.conditions
        ? item.conditions.includeNameAndEmail
        : null,
      selectedEvent: item.conditions
        ? { id: item.conditions.selectedEvent }
        : null,
      showEventFilter:
        item.conditions && item.conditions.selectedEvent ? true : false
    });
    if (item.conditions && item.conditions.selectedEvent) {
      this.props.updateEvents(eventBuckets[0]);
    }
  }

  handleCloseClick() {
    this.props.close();
  }

  handleParentStateUpdate() {
    let parentState = {};
    if (this.state.selectedBuckets) {
      parentState.selectedBuckets = this.state.selectedBuckets;
    }
    let conditions = {};
    conditions.timePeriod = this.state.grouping;
    if (this.state.tType) {
      conditions.tType = this.state.tType;
    }
    if (this.state.tClass) {
      conditions.tClass = this.state.tClass;
    }
    if (this.state.showEventFilter) {
      conditions.selectedEvent = this.state.selectedEvent.id;
    }
    conditions.includeNameAndEmail = this.state.includeNameAndEmail;
    parentState.conditions = conditions;
    parentState.nickname = this.state.nickname;
    const isComplete =
      this.state.selectedBuckets && this.state.selectedBuckets.length > 0;
    this.props.update(parentState, isComplete);
  }

  getStyles() {
    return {
      widgetWrapper: {
        backgroundColor: "#eee",
        boxSizing: "border-box",
        padding: "30px",
        width: "100%",
        borderRadius: "1em"
      },
      widgetTitle: {
        float: "left",
        overflow: "visible",
        fontWeight: "bold",
        fontSize: "15px"
      },
      reportTypeWrapper: {
        clear: "both",
        float: "left",
        marginTop: "-5px"
      },
      textInput: {
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "3px",
        height: "20px",
        width: "60%",
        minWidth: "400px",
        fontSize: "13px",
        padding: "8px"
      },
      fieldLabel: {
        color: "#737373",
        fontWeight: "bold",
        marginBottom: 2
      }
    };
  }

  render() {
    const styles = this.getStyles();

    return (
      <div>
        <div style={{ width: "100%", paddingTop: "10px" }}>
          <div style={styles.fieldLabel}>Report Name</div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start"
            }}
          >
            <input
              value={this.state.nickname}
              style={styles.textInput}
              onChange={e => {
                this.setState(
                  { nickname: e.target.value },
                  this.handleParentStateUpdate
                );
              }}
            />
          </div>
        </div>
        <div style={{ width: "100%", paddingTop: "10px" }}>
          <div style={styles.fieldLabel}>Event Bucket</div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start"
            }}
          >
            <InjectedSelect
              style={{ minWidth: "400px" }}
              placeholder={
                this.state.showEventFilter === true
                  ? "Select event bucket..."
                  : "Select event bucket(s)..."
              }
              clearable={false}
              value={
                this.state.showEventFilter === true &&
                this.state.selectedBuckets.length === 0
                  ? null
                  : this.state.selectedBuckets
              }
              types={["event_buckets"]}
              multi={this.state.showEventFilter === true ? false : true}
              labelFormatter={b => b.name}
              onChange={e => {
                this.setState(
                  {
                    selectedBuckets: e,
                    selectedEvent: null
                  },
                  () => {
                    if (this.state.showEventFilter === true) {
                      this.props.updateEvents(e);
                    }
                    this.handleParentStateUpdate();
                  }
                );
              }}
            />
          </div>
        </div>
        <div style={{ width: "100%", paddingTop: "10px" }}>
          <div style={styles.fieldLabel}>Grouping</div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start"
            }}
          >
            <RadioButtonGroup
              name="groupingRadioGroup"
              valueSelected={this.state.grouping}
              onChange={(e, v) => {
                this.setState(
                  { grouping: v, showEventFilter: false, selectedEvent: null },
                  this.handleParentStateUpdate
                );
              }}
            >
              {transactionLogGroups.map(item => {
                return (
                  <RadioButton
                    style={{ display: "inline-block", width: 200 }}
                    value={item.value}
                    label={item.label}
                  />
                );
              })}
            </RadioButtonGroup>
          </div>
        </div>
        {this.state.grouping === "NO GROUPING" ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              paddingTop: "10px",
              paddingBottom: "5px"
            }}
          >
            <Checkbox
              label="Filter by a single event"
              checked={this.state.showEventFilter}
              onClick={e => {
                //adjust existing event bucket selection values
                let selectedBuckets = [];
                if (e.target.checked) {
                  if (this.state.selectedBuckets.length > 0) {
                    selectedBuckets = this.state.selectedBuckets[0];
                  } else {
                    selectedBuckets = null;
                  }
                } else {
                  selectedBuckets = [this.state.selectedBuckets];
                  this.setState({
                    selectedEvent: null
                  });
                }
                this.setState(
                  {
                    showEventFilter: e.target.checked,
                    selectedBuckets: selectedBuckets
                  },
                  () => {
                    this.props.updateEvents(selectedBuckets);
                    this.handleParentStateUpdate();
                  }
                );
              }}
            />
          </div>
        ) : null}
        {this.state.grouping === "NO GROUPING" && this.state.showEventFilter ? (
          <div style={{ paddingTop: 10 }}>
            <div style={styles.fieldLabel}>Filter by Event</div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start"
              }}
            >
              <Select
                multi={false}
                clearable={false}
                value={
                  this.state.selectedEvent ? this.state.selectedEvent.id : null
                }
                style={{ width: 450 }}
                delimeter=","
                onChange={item => {
                  this.setState(
                    { selectedEvent: item },
                    this.handleParentStateUpdate
                  );
                }}
                options={this.props.events}
              />
            </div>
          </div>
        ) : null}
        <div style={{ width: "100%", paddingTop: "10px" }}>
          <div className="pull-left">
            <div style={styles.fieldLabel}>Filter by Transaction Type</div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                paddingBottom: "10px"
              }}
            >
              <Select
                multi={true}
                clearable={false}
                value={this.state.tType}
                style={{ width: 280 }}
                delimeter=","
                onChange={item => {
                  this.setState({ tType: item }, this.handleParentStateUpdate);
                }}
                options={[
                  { value: "PAYMENT", label: "Payment" },
                  { value: "ADJUSTMENT", label: "Adjustment" },
                  { value: "REFUND", label: "Refund" }
                ]}
              />
            </div>
          </div>
          <div className="pull-left" style={{ paddingLeft: 25 }}>
            <div style={styles.fieldLabel}>Filter by Transaction Class</div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start"
              }}
            >
              <Select
                multi={true}
                clearable={false}
                value={this.state.tClass}
                style={{ width: 280 }}
                delimeter=","
                onChange={item => {
                  this.setState({ tClass: item }, this.handleParentStateUpdate);
                }}
                options={[
                  { value: "TICKET", label: "Ticket" },
                  { value: "INGEST", label: "Ingest" },
                  { value: "PASS", label: "Pass" },
                  { value: "ITEM", label: "Item" },
                  { value: "TAX", label: "Tax" }
                ]}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            paddingTop: "10px",
            paddingBottom: "10px"
          }}
        >
          <Checkbox
            label="Include purchaser name and email columns"
            checked={this.state.includeNameAndEmail}
            onClick={e => {
              this.setState(
                {
                  includeNameAndEmail: e.target.checked
                },
                this.handleParentStateUpdate
              );
            }}
          />
        </div>
      </div>
    );
  }
}

export default CustomLedgerScheduleView;



// WEBPACK FOOTER //
// ./src/app/components/partials/schedule-views/custom-ledger-schedule-view.jsx